import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponseCatalog, LocalityItem } from '../models/catalogs/catalogs-model';
import { GeneralService } from './general.service';

@Injectable({
  providedIn: 'root',
})
export class PostalCodeService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public getLocalities(
    postalCode: string | number,
  ): Observable<ApiResponseCatalog<LocalityItem[]> | null> {
    const params = this.generalService.buildParams({ postalCode });
    return this.http
      .get<ApiResponseCatalog<LocalityItem[]>>(`${this.URL_API}/api/PostalCode/GetLocalities`, {
        params,
      })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
}
